<template>

    <header class="header">

        <div class="header__container">

            <router-link
                :to="{ path: '/', hash: '#hero' }"
                class="header__logo"
                @click.native="closeMenu"
            >

                <img
                    class="header__logo-img"
                    :src="'header_logo' | staticImg"
                    :alt="'header_logo' | staticTitle"
                >

            </router-link>

            <nav
                class="header__nav"
                :class="{ active: menuOpen }"
            >

                <ul class="header__menu">

                    <li
                        v-for="item in navigation"
                        :key="item.hash"
                    >

                        <router-link
                            :to="item.to"
                            @click.native="closeMenu"
                        >
                            {{ item.hash | staticTitle }}
                        </router-link>

                    </li>

                </ul>

                <router-link :to="{ name: 'Page', params: { slug: 'ofrendar' } }" class="header__button" @click.native="closeMenu" >
                    {{ 'Ofrendar' | i }}
                </router-link>

            </nav>

            <button
                type="button"
                class="header__toggle"
                :class="{ active: menuOpen }"
                :aria-expanded="menuOpen ? 'true' : 'false'"
                aria-label="Toggle navigation"
                @click="toggleMenu"
            >

                <span></span>
                <span></span>
                <span></span>

            </button>

        </div>

        <div
            v-if="menuOpen"
            class="header__overlay"
            @click="closeMenu"
        ></div>

    </header>

</template>

<script>
export default {
    name: 'navHeader',

    data() {
        return {
            menuOpen: false,

            navigation: [
                {
                    hash: 'nav_about',
                    to: {
                        path: '/',
                        hash: '#about'
                    }
                },
                {
                    hash: 'nav_ministries',
                    to: {
                        path: '/',
                        hash: '#ministries'
                    }
                },
                {
                    hash: 'nav_sermons',
                    to: {
                        name: 'Sermons'
                    }
                },
                {
                    hash: 'nav_resources',
                    to: {
                        path: '/',
                        hash: '#resources'
                    }
                },
                {
                    hash: 'nav_contact',
                    to: {
                        path: '/',
                        hash: '#contact'
                    }
                },
                // {
                //     hash: 'ofrendar',
                //     to: {
                //         path: '/pagina/ofrendar',
                //         hash: '#ofrendar'
                //     }
                // }
            ]
        };
    },

    watch: {
        '$route.path'() {
            this.closeMenu();
        }
    },

    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
            this.updateBodyScroll();
        },

        closeMenu() {
            this.menuOpen = false;
            this.updateBodyScroll();
        },

        updateBodyScroll() {
            document.body.style.overflow = this.menuOpen ? 'hidden' : '';
        }
    },

    beforeDestroy() {
        document.body.style.overflow = '';
    }
};
</script>

<style lang="scss" scoped>
.header {
    position: fixed;

    top: 0;
    left: 0;

    width: 100%;

    background: rgba(255, 255, 255, .96);

    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    box-shadow: 0 2px 20px rgba(0, 0, 0, .08);

    z-index: 1000;

    &__container {
        position: relative;

        width: 100%;
        max-width: 1400px;

        margin: 0 auto;
        padding: 12px 20px;

        display: flex;
        align-items: center;
        justify-content: space-between;

        z-index: 1002;
    }

    &__logo {
        display: block;

        width: 120px;

        flex-shrink: 0;
    }

    &__logo-img {
        display: block;

        width: 60%;
        height: auto;
    }

    &__nav {
        position: fixed;

        top: 0;
        right: -100%;

        width: 280px;
        max-width: 86vw;
        height: 100vh;

        padding: 90px 20px 30px;

        background: var(--background);

        transition: right .35s ease;

        z-index: 1001;

        overflow-y: auto;

        &.active {
            right: 0;
        }
    }

    &__menu {
        display: flex;
        flex-direction: column;

        gap: 26px;

        a {
            color: var(--text);

            font-size: .88rem;
            font-weight: 600;

            letter-spacing: .5px;

            text-transform: uppercase;

            transition: color .25s ease;

            &:hover {
                color: var(--primary);
            }
        }
    }

    &__button {
        min-height: 44px;

        display: flex;
        align-items: center;
        justify-content: center;

        margin-top: 34px;

        padding: 0 22px;

        background: var(--primary);
        color: var(--white);

        border-radius: 4px;

        font-size: .82rem;
        font-weight: 700;

        text-transform: uppercase;

        transition:
            background .3s ease,
            transform .3s ease;

        &:hover {
            background: var(--primary-hover);

            transform: translateY(-2px);
        }
    }

    &__toggle {
        position: relative;

        width: 38px;
        height: 38px;

        display: flex;
        flex-direction: column;
        justify-content: center;

        gap: 6px;

        padding: 0;

        z-index: 1003;

        span {
            display: block;

            width: 100%;
            height: 3px;

            background: var(--text);

            border-radius: 20px;

            transition:
                transform .3s ease,
                opacity .3s ease;
        }

        &.active {

            span:nth-child(1) {
                transform: translateY(9px) rotate(45deg);
            }

            span:nth-child(2) {
                opacity: 0;
            }

            span:nth-child(3) {
                transform: translateY(-9px) rotate(-45deg);
            }
        }
    }

    &__overlay {
        position: fixed;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background: rgba(0, 0, 0, .35);

        z-index: 1000;
    }
}

@media (min-width: 1100px) {
    .header {

        &__container {
            max-width: 1400px;

            padding: 10px 24px;
        }

        &__logo {
            width: 210px;
        }

        &__nav {
            position: static;

            width: auto;
            max-width: none;
            height: auto;

            padding: 0;

            display: flex;
            align-items: center;

            gap: 28px;

            background: transparent;

            overflow: visible;
        }

        &__menu {
            flex-direction: row;

            gap: 26px;
        }

        &__button {
            margin-top: 0;

            padding: 0 22px;
        }

        &__toggle {
            display: none;
        }

        &__overlay {
            display: none;
        }
    }
}
</style>